<template>
  <v-navigation-drawer
    app
    right
    fixed
    temporary
    touchless
    id="skinBooks"
    class="sidebar"
    v-model="drawer"
    :width="width"
    v-if="book"
  >
    <v-container>
      <v-row>
        <v-col
          align-self="center"
          class="py-0 mt-0">
          <v-card
            :loading="loading"
            class="mx-auto sidebar-card"
          >
            <template slot="progress">
              <v-progress-linear
                color="primary"
                height="10"
                indeterminate
              ></v-progress-linear>
            </template>

              <v-row
                align="center"
                class="mx-0"
              >
              <v-col class="pt-0">
                <v-img
                  :width="imageW"
                  class="mx-auto"
                  :src="`https://assets.beeverso.org/lbr/image/${book.resourceDir}/cover_medium.jpg`"
                ></v-img>
              </v-col>
            </v-row>
            <v-row
                align="center"
                class="mx-0"
              >
              <v-col class="px-5">
                <v-card
                  elevation="0"
                  class="sidebar-card-scroll"
                >
                  <v-card-title class="d-block justify-content-center">{{book.title}}</v-card-title>
                  <v-card-subtitle v-if="book.authorDTO">
                    {{book.authorDTO}}
                  </v-card-subtitle>
                  <v-card-text color="darkText" class="text-left py-0">
                    <p>{{book.bookAbstract}}</p>
                  </v-card-text>
                  <v-card-actions class="justify-content-center">

                        <v-chip
                            label
                            color="white"
                            class="mr-1"
                            v-if="book.textType"
                          >
                          <v-img
                            :src="iconCategory"
                            max-height="24"
                            max-width="24"
                            class="mr-1"
                            ></v-img>
                          {{ book.textType.name }}
                        </v-chip>

                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>

            <v-card-actions class="pb-5">
              <v-row
                class="px-0 px-md-3"
                justify="center"
                align="center">
                <v-col
                  data-cy="myList-btn-sidebar"
                  class="pa-0 pa-md-3"
                  cols="3"
                  offset="">
                    <FavoriteRibbon :selected="bookFavoriteForUser" :setFavorite="setFavorite" />
                    <small class="text-nowrap mt-2 d-block">{{ $t('library.my_list') }}</small>
                </v-col>
                <v-col
                  class="pa-0 pa-md-3"
                  cols="3">
                  <v-btn
                    data-cy="read-btn-sidebar"
                    class=""
                    fab
                    dark
                    large
                    color="primary"
                    depressed
                    @click="$router.push(`/user/book/${book.id}`)"
                  >
                    <v-img
                      contain
                      height="20"
                      width="20"
                      :src="bookRead"
                    ></v-img>
                  </v-btn>
                  <br>
                  <strong><small class="text-primary">
                    {{ $t('library.title_button_card') }}
                  </small></strong>
                </v-col>
              </v-row>

              <v-alert
                data-cy="addedTo-alert-validation"
                :value="bookAlert"
                color="rgba(119, 100, 202, 0.7)"
                dark
                transition="scale-transition"
                class="w-80"
              >
                <v-row>
                  <v-col  class="pa-0">
                    <v-img
                      contain
                      max-height="24"
                      max-width="24"
                      :src="myBooks"
                      class="d-inline-flex align-middle"
                    ></v-img>
                    {{ msg }}
                    <strong class="text-nowrap ml-1 mt-1">{{$t('library.my_list')}}</strong>
                  </v-col>
                </v-row>
              </v-alert>
            </v-card-actions>

          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import BookService from '@/services/book'
import UserSkinService from '../../services/userSkin'
// eslint-disable-next-line camelcase
import { backend_responses } from '@/constants/DefaultConstants'
import BookUserFavoriteService from '@/services/bookUserFavorite'
import FavoriteRibbon from '../reading/core/FavoriteRibbon.vue'

export default {
    data() {
        return {
            bookAlert: false,
            drawer: null,
            group: null,
            loading: false,
            msg: '',
            skinDefault: require('@/assets/img/skins/skin-01.png'),
            iconCategory: require('@/assets/img/icons/navbar/home.png'),
            addList: require('@/assets/img/icons/add-list.svg'),
            addedList: require('@/assets/img/icons/added-list.svg'),
            myBooks: require('@/assets/img/icons/my-books.svg'),
            bookRead: require('@/assets/img/icons/book-read.svg'),
            book: [],
            selectedSkin: null,
        }
    },
    components: {
      FavoriteRibbon,
    },
    async mounted() {
        this.$root.$on('toggleDrawer', this.toggleDrawer, this.book)
    },
    computed: {
      ...mapState({
        bookFavoriteForUser: (state) => state.bookReading.bookFavoriteForUser,
        user: (state) => state.userData.user,
      }),
        isBook() {
            return this.book !== null
        },
        width() {
            if (this.$vuetify.breakpoint.xs) {
                return 320
            }
            if (this.$vuetify.breakpoint.sm) {
                return 360
            }
            if (this.$vuetify.breakpoint.lg) {
                return 380
            }
            if (this.$vuetify.breakpoint.xl) {
                return 400
            }
            return 380
        },
        imageW() {
          if (this.$vuetify.breakpoint.xs) {
              return 180
          }
          if (this.$vuetify.breakpoint.sm) {
              return 200
          }
          if (this.$vuetify.breakpoint.md) {
              return 220
          }
          if (this.$vuetify.breakpoint.lg) {
              return 240
          }
          return 280
        }
    },
    methods: {
      ...mapActions('bookReading', [
          'setBookFavoriteForUser',
          'setBook',
          'setBookFavoriteForUserValue',
      ]),
        toggleDrawer(book) {
          this.book = book
          this.drawer = !this.drawer
          this.loadBook()
        },
        async loadBook(){
          await BookService.getBookSummaryInfo(this.book.id, this.user.id, 'MYSELF')
            .then((response) => {
                if (backend_responses[response.status.code] === 'ERROR') {
                    throw new Error(this.$t('general.error_msg'))
                }
                const {
                    bookDTO,
                    bookFavoriteForUser,
                } = response.content
                // this.setBook(bookDTO)
                this.setBookFavoriteForUserValue(bookFavoriteForUser)
            })
            .catch((error) => {
                console.log(error)
                Sentry.captureException(error)
                this.$modal.loadError()
            })
        },
        setFavorite() {
          if (this.user.id && this.book.id){
            if (!this.bookFavoriteForUser){
                this.$ga.event('userClick', 'bookFavorite', 'Add book to favorite')
                BookUserFavoriteService.addFavoriteBookToUser({
                    user: { id: this.user.id },
                    book: { id: this.book.id },
                }).catch((error) => Sentry.captureException(error))
                this.setBookFavoriteForUserValue(true)
                this.bookAlert = true
                this.msg = this.$t('library.added_to')
                setTimeout(() => {
                    this.bookAlert = false
                }, 3000)
            } else {
                this.$ga.event('userClick', 'bookUnFavorite', 'remove book from favorites')
                BookUserFavoriteService.deleteFavoriteBookToUser(
                    this.user.id,
                    this.book.id
                ).catch((error) => Sentry.captureException(error))
                this.setBookFavoriteForUserValue(false)
                this.bookAlert = true
                this.msg = this.$t('library.delete_to')
                setTimeout(() => {
                    this.bookAlert = false
                }, 3000)
            }
          }
        },
        setDesktop(skin) {
          let cardBanner = document.getElementById('skinBooks')
          if (!skin && cardBanner){
            cardBanner.style.backgroundImage = this.skinDefault
            return
          }
          const img = skin?.resources.find((res) => res.resourceUrl.includes('desktop'))
          cardBanner.style.backgroundImage = `url("https://assets.beeverso.org/skins/${img.resourceUrl}")`
        },
        getSelectedSkin() {
          UserSkinService.getSelectedByUser(this.user.id)
            .then((response) => {
              this.selectedSkin = response.content
              this.setDesktop(response.content)
            })
            .catch((error) => console.error(error))
        },
    },
    created() {
      this.getSelectedSkin()
    },
}
</script>
<style lang="scss" scoped>
.sidebar{
  background-size: cover;
  &.v-navigation-drawer{
    box-shadow: 4px 0px 50px rgba(0, 0, 0, 0.05);
  }
  &-card{
    border-radius: 1rem;
    background-color: rgba(255, 255, 255, 0.8);
    position: relative;
    &:before{
      content:'';
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      backdrop-filter: blur(6px);
      border-radius: 1rem;
      z-index: -1;
    }
    .v-btn{
      &:not(.primary){
        color: #4B5768;
      }
      &.primary{
        background: linear-gradient(310.15deg, #A295DA -3.77%, #7764CA 29.51%, #6857B2 65.63%, #514585 93.49%);
        box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
        & + span{
          color: #7764CA;
          font-weight: 600;
        }
      }
      & + span{
        white-space: nowrap;
        font-size: .85rem;
      }
      @media (max-width: 600px) {
        &.v-btn--fab.v-btn--round:not(.primary){
          & + span{
            font-size: .85rem;
          }
        }
      }
    }
    &-scroll{
      background-color: rgba(255, 255, 255, 0.45);
      border-radius: .5rem;
      .v-card{
        &__title{
          word-break: keep-all;
          line-height: 130%;
        }
        &__text{
          height: auto;
          max-height: 13rem;
          overflow-y: auto;
          @media screen and (max-height: 768px) {
            max-height: 4rem;
          }
          p{
            margin-bottom: 0;
            & + p{
              margin-top: 16px;
            }
          }
          &::-webkit-scrollbar-track{
            background-color: rgba(50, 58, 70, 0.2);
          }
          &::-webkit-scrollbar {
            width: 0.5em;
            height: 0.5em;
          }
          &::-webkit-scrollbar-thumb {
            background-color: rgba(50, 58, 70, 1);
            border-radius: 3px;
          }
        }
      }
      .v-btn{
        background-color: white;
        text-transform: none;
        @media (max-width: 599px) {
          font-size: .75rem;
        }
      }
    }
  }
  .v-image__image--cover{
    background-image: contain !important;
  }
}
.v-item-group{
  .v-chip:hover:before{
    opacity: 0;
  }
}
.v-alert{
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
}

.text-primary{
  color: rgba(119, 100, 202, 1);
}
</style>
